import TileWMS from 'ol/source/TileWMS.js';

function tileWms({ url, params }) {
	return new TileWMS({
		url,
    params
	});
}

export default tileWms;
